import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../helpers/axiosInstance";

const initialState = {
    status: false,
    loading: false,
};

export const generateLoa = createAsyncThunk("generateLoa", async ({data,companyName}) => {
    try {
        const response = await axiosInstance.post("/generate_loa", data,{
            headers: {
                "Content-Type": "application/json",
            },
            responseType: "blob", //Set response type to 'blob' for binary data
        });
        
        // Create a URL for the blob and log it
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
        const url = URL.createObjectURL(blob);

        // trigger a download
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${companyName} - LOA.docx`   ); // Set the file name
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        return true;
    } catch (error) {
        throw new Error(error.response.data.message || 'Something went wrong');
    }
});

export const generateSlice = createSlice({
    name: "generateLoa",
    initialState,
    reducers: {
        clearState: (state) => {
            state.status = false;
            state.loading = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(generateLoa.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(generateLoa.fulfilled, (state) => {
            state.loading = false;
            state.status = true;
        });
        builder.addCase(generateLoa.rejected, (state) => {
            state.loading = false;
        });
    },
});

export default generateSlice.reducer;